import type * as THREE from "three";
import { createToken, type IService } from "@designboticteam/core";

type SyncDirection = "map-to-workspace-3d" | "workspace-3d-to-map";

interface IMapLibreCameraSyncService extends IService {
	readonly syncDirection: SyncDirection;
	synchronizeCamera(params: { cameraProjectionMatrix: THREE.Matrix4; modelMatrix: THREE.Matrix4 } | { camera: THREE.PerspectiveCamera }): void;
}

const MAPLIBRE_CAMERA_SYNC_SERVICE = createToken<IMapLibreCameraSyncService>("IMapLibreCameraSyncService");

export { type IMapLibreCameraSyncService, MAPLIBRE_CAMERA_SYNC_SERVICE, type SyncDirection };
